import { createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentExtractionCategory } from '../../../enums/document-extraction-category.enum';
import { DocumentExtractionUploadResult } from '../../../models/DocumentExtraction/document-extraction-upload-result';

const SIZE_LIMIT_EXCEEDED_STATUS = 413;
const SIZE_LIMIT_MESSAGE = 'File exceeds the 100 MB limit';
const GENERIC_UPLOAD_FAILURE_MESSAGE = 'Upload failed. Please try again.';

export const extractUploadFailureReason = (failure: any): string => {
    const httpResponse = failure?.response ?? failure;
    if (httpResponse?.status === SIZE_LIMIT_EXCEEDED_STATUS) {
        return SIZE_LIMIT_MESSAGE;
    }
    if (httpResponse?.data?.title) {
        return httpResponse.data.title;
    }
    return GENERIC_UPLOAD_FAILURE_MESSAGE;
};

export interface UploadDocumentForExtractionRequest {
    localId: string;
    category: DocumentExtractionCategory;
    file: File;
}

export interface UploadDocumentForExtractionRejection {
    localId: string;
    reason: string;
}

export const UploadDocumentForExtraction = createAsyncThunk<
    DocumentExtractionUploadResult,
    UploadDocumentForExtractionRequest,
    { rejectValue: UploadDocumentForExtractionRejection }
>(
    'documentExtraction/uploadDocument',
    async (params, thunkApi) => {
        const axios = (thunkApi.getState() as any).core.axios;
        const formData = new FormData();
        formData.append('file', params.file);

        const rejectWithReason = (failure: any) =>
            thunkApi.rejectWithValue({
                localId: params.localId,
                reason: extractUploadFailureReason(failure),
            });

        try {
            const response = await axios.post(
                `/api/DocumentExtraction/${params.category}`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response?.status !== 200) {
                return rejectWithReason(response);
            }

            return response.data as DocumentExtractionUploadResult;
        } catch (error) {
            return rejectWithReason(error);
        }
    }
);
